
export function Nfc() {
	return null
}

export default Nfc
